import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../SubscriptionDowngrade.module.css';

const PlanDescription = () => {
  const { t } = useTranslation();
  
  return (
    <div className={styles.planDescription}>
      <p className={styles.noHiddenCharges}>{t('subscription.no_hidden_charges')}</p>
      <p className={styles.description}>{t('subscription.plan_description')}</p>
    </div>
  );
};

export default PlanDescription; 